// The hosted sign-in screen's address.
//
// Kept apart from `authApi` so the fetch wrapper can build it too: `authApi`
// imports `apiClient`, and `apiClient` needs this address on a 401, so living
// in either module would make the two import each other.

export type HostedAuthScreen = "login" | "signup";

/**
 * The address of Logto's hosted screen. `returnTo` names the app page to come
 * back to once signed in: the server keeps it on the session and the sign-in
 * callback lands there instead of on the dashboard — so a bookmark, a link a
 * colleague sent, or a session that ran out mid-use returns to its own page.
 */
export function buildHostedAuthPath(screen: HostedAuthScreen, returnTo?: string | null): string {
    const params = new URLSearchParams();

    if (screen === "signup") {
        params.set("first_screen", "register");
    }
    if (returnTo) {
        params.set("returnTo", returnTo);
    }

    const query = params.toString();
    return query ? `/logto/sign-in?${query}` : "/logto/sign-in";
}
